import { useEffect } from "react";
const useOnClickOutside = (ref, handler, isOn = true) => {
  useEffect(() => {
    if (isOn) {
      const listener = (event) => {
        event.stopPropagation();
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }
  }, [ref, handler, isOn]);
};

export default useOnClickOutside;
